import React, { ReactNode } from "react"

import axios from "axios"
import { toast } from "react-toastify"
import { z } from "zod"
import { DEFAULT_ERROR } from "./constants"

const getErrorMessage = (error: any) => {
  return constructError(error).message
}

interface ErrorResponse {
  error: boolean
  message: string
  type: string
  statusCode: number | null
}

const problemDetailsSchema = z.object({
  type: z.string(),
  title: z.string(),
  status: z.number(),
  detail: z.string().optional(),
  errors: z.record(z.string(), z.array(z.string())).optional(),
})

function constructError(error: any): ErrorResponse {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data

    const parsedData = problemDetailsSchema.safeParse(data)

    // Problem Details
    if (parsedData.success) {
      const flatErrors = parsedData.data.errors ? Object.values(parsedData.data.errors).flat() : []

      console.log(flatErrors)

      return {
        error: true,
        message: flatErrors.length > 0 ? flatErrors.join("\n\n") : parsedData.data.detail || DEFAULT_ERROR,
        type: parsedData.data.type,
        statusCode: parsedData.data.status || null,
      }
    }
  }

  const returnError = {
    error: true,
    message: error.message || DEFAULT_ERROR,
    type: error.type,
    statusCode: null,
  }

  if (error?.response?.data && !error.type) {
    if (error.response.data.message) {
      try {
        const json = JSON.parse(error.response.data.message)

        if (!json.message) {
          throw "Message is not JSON"
        }
        returnError.message = json.message
      } catch {
        returnError.message = error.response.data.message
      }
    } else if (error?.response?.data?.errors?.key?.length ?? 0 !== 0) {
      returnError.message = error.response.data.errors.key.join("\n")
    } else if (
      !!error?.response?.data &&
      (typeof error?.response?.data === "string" || error?.response?.data instanceof String)
    ) {
      returnError.message = error?.response?.data
    }
  }
  if (error && error.response) {
    returnError.statusCode = error.response.status
  }

  if (returnError.message == DEFAULT_ERROR && (typeof error === "string" || error instanceof String) && !!error) {
    returnError.message = error
  }

  return returnError
}

const getErrorContent = (title: string, e: any) => {
  const error = React.isValidElement(e) ? e : <p className="sub-heading">{constructError(e).message}</p>

  return (
    <>
      <p>{title}</p>
      {error}
    </>
  )
}

function showToast(title: string, e: any) {
  showWarning(getErrorContent(title, e))
}

function showWarning(content: ReactNode, autoClose: false | number = false) {
  toast.warning(content, { autoClose: autoClose })
}

export { constructError, getErrorContent, getErrorMessage, showToast, showWarning }
